/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from '../transformer';
import StudentJobListTransformer from './studentJobList';
import Address from '../common/address';
import EmbedUser from './embedUser';

export default class JobDetail extends Transformer {
  /**
   * Method used to transform from API to application model
   *
   * @param job Job
   *
   * @returns {Object} The transformed account
   */
  static fetch(job) {
    return {
      id: job.id,
      dateBegin: job.date_begin,
      dateEnd: job.date_end,
      hourBegin: job.hour_begin,
      hourEnd: job.hour_end,
      additional_job_infos: job.additional_job_infos,
      students: StudentJobListTransformer.fetchCollection(job.students),
      address: Address.fetch(job.address),
      brandAmbassador: job.brand_ambassador ? EmbedUser.fetch(job.brand_ambassador) : null,
      owner: job.owner ? EmbedUser.fetch(job.owner) : null,
      referer: job.referer ? EmbedUser.fetch(job.referer) : null,
      tags: job.tags,
      category: job.category,
      description: {
        description: job.description,
        descriptionOffer: job.offer_description,
        descriptionSkillsNeeded: job.description_skills_needed,
        descriptionOtherInfos: job.description_other_infos,
        descriptionStudentPopAdvantage: job.description_student_pop_advantage,
      },
      descriptionSkillsNeeded: job.description_skills_needed,
      dressCode: job.dress_code,
      contactPhoneNumber: job.contact_phone_number,
      countRefererStaffed: job.count_referer,
      countRefererAsked: job.count_referer_asked,
      countStudentStaffed: job.count_student,
      countStudentAsked: job.count_student_asked,
      customer: job.customer,
      finished: job.finished,
      globalFeedback: job.global_feedback,
      lunchMealAmount: job.lunch_meal_amount,
      breakTimeMinutes: job.break_time_minutes,
      tempAssignmentReason: job.temp_assignment_reason ? {
        type: job.temp_assignment_reason.type,
        description: job.temp_assignment_reason.description,
        absenceReason: job.temp_assignment_reason.absence_reason,
      } : null,
    };
  }
}
